var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconJrPackage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.912 2a4.513 4.513 0 012.05-.5H15v1H8.975c-.55 0-1.112.138-1.6.388l-1.688.862h2.688l-1.625 1h-3l.087-.05-1.5.763c-.212.1-.337.274-.337.462 0 .313.362.575.788.575H5v1H2.788C1.8 7.5 1 6.8 1 5.925c0-.55.337-1.075.887-1.35L6.913 2z",
    fill: "#6D6D6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.75h1v1h-1v-1zM15 3.75h-1v1h1v-1zM10 3.75h1v1h-1v-1zM12 10.5h-1.5v-1H12v1zM8 10.5h1.5v-1H8v1zM12 12.5h-1.5v-1H12v1zM8 12.5h1.5v-1H8v1z",
    fill: "#6D6D6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 13.5h1v1H5v-1h1v-6h1.5v-1h5v1H14v6zm-1-5v5H7v-5h6z",
    fill: "#6D6D6D"
  })));
}

export default SvgIconJrPackage;